import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operator", "field", "value"]
  connect() {
    setTimeout(() => {
      this.handle()
    }, 400)
    console.log("connected", this.element)
  }

  handle() {
    const operator = this.operatorTarget.value
    const field = this.fieldTarget.value
    const value = this.valueTarget.value

    this.dispatch("change", {
      detail: { operator: operator, args: [field, value] }
    })
  }

  remove() {
    const operator = this.operatorTarget.value
    const field = this.fieldTarget.value
    const value = this.valueTarget.value

    this.dispatch("remove", {
      detail: { operator: operator, args: [field, value] }
    })


    this.element.remove()
  }
}
